export default "__VITE_ASSET__CNqOJnmx__"